export default "/images/vendor/flag-icon-css/flags/1x1/zw.svg?3a3eb0f2bf0ffd8f5201303fa8383677";